import React, { useState, useEffect } from "react";
import "./footer.css";
import RightArrow from "../../../assets/images/arrow.png";
import Location from "../../../assets/images/location.png";
import mailfoot from "../../../assets/images/emailfoot1.png";
import Loc from "../../../assets/images/loc.png";
import { NavLink } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import Client from "../axiosApi";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [service, setService] = useState();

  const navigate = useNavigate();

  const getService = async () => {
    try {
      const serviceResponse = await Client.get("/service/getAll");
      console.log(serviceResponse.data.getAll);

      if (serviceResponse.status === 200) {
        const services = serviceResponse.data.getAll;

        setService(services);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getService();
  }, []);

  const getEach = (id, service) => {
    console.log("geteach");
    navigate(`/${service}/${id}`);
  };
  return (
    <>
      <footer className="ssfooter">
        <div className="container-fluid">
          <div className="footerlinks">
            <div className="row">
              <div className="col-md-3 mt-4">
                {/* <img src="" /> */}
                <h5 className="aboutfootertitle">About Us</h5>
                <p className="footabout">
                  SaaSphire specializes in delivering innovative Salesforce
                  solutions to help businesses grow and excel. We streamline
                  operations, enhance customer experiences, and provide tailored
                  strategies.
                </p>
              </div>

              <div className="col-md-3 mt-4 footersections">
                <h5>Quick Links</h5>
                <ul className="quicklinks">
                  <li>
                    <NavLink to="/">
                      <img src={RightArrow} alt="arrow" />
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">
                      <img src={RightArrow} alt="arrow" />
                      Who We Are
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/what-we-do">
                      <img src={RightArrow} alt="arrow" />
                      What We Do
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">
                      <img src={RightArrow} alt="arrow" />
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div className="col-md-3 mt-4 footersections">
                <h5>Service</h5>
                <ul className="quicklinks">
                  {service &&
                    service.map((each, index) => {
                      return (
                        <li>
                          <NavLink to={`/${each.service}/${each._id}`}>
                            <img src={RightArrow} alt="arrow" />
                            {each.service}
                          </NavLink>
                        </li>
                      );
                    })}
                </ul>
              </div>

              <div className="col-md-3 mt-4 footersections">
                <h5>Reach Us</h5>
                <ul className="quicklinks">
                  <li className="footaddress">
                    <img src={Loc} alt="location" />
                    <span>The Long Lodge, 265-269, Kingston Road, United Kingdom, Wimbledon, SW193NW</span>
                  </li>
                  {/* <li className="footmail">
                    <img src={mailfoot} alt="location" />
                    <span>info@sscasa.com</span>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="copyright">
              <p>2022 SAASPHIRE, Inc. ALL RIGHTS RESERVED.</p>
              {/* <div className="socialmedialinks">
                <FaXTwitter className="social-icon" />
                <FaInstagram className="social-icon" />
              </div> */}
            </div>
          </div>

          <hr style={{ color: "#8c9da7" }} />

          {/* <div className="companydetails">
            <div className="terms-privacy">
              <NavLink to="/terms">Terms of Service</NavLink>&nbsp;
              <span>|</span>&nbsp;
              <NavLink to="/terms">Privacy Policy</NavLink>
            </div>
          </div> */}
        </div>
      </footer>
    </>
  );
};

export default Footer;
